import HanaDark from "../HanaDark";
import HanaLight from "../HanaLight";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Hana = function Hana(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    rootClassName = _ref.rootClassName;
  return /*#__PURE__*/_jsxs("span", {
    className: rootClassName,
    children: [/*#__PURE__*/_jsx("span", {
      className: "tw-inline-block dark:tw-hidden",
      children: /*#__PURE__*/_jsx(HanaLight, {
        size: size,
        className: className
      })
    }), /*#__PURE__*/_jsx("span", {
      className: "tw-hidden dark:tw-inline-block",
      children: /*#__PURE__*/_jsx(HanaDark, {
        size: size,
        className: className
      })
    })]
  });
};
export default Hana;